import { render, staticRenderFns } from "./ditu.vue?vue&type=template&id=b3ed0cbe&scoped=true&"
import script from "./ditu.vue?vue&type=script&lang=js&"
export * from "./ditu.vue?vue&type=script&lang=js&"
import style0 from "./ditu.vue?vue&type=style&index=0&id=b3ed0cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ed0cbe",
  null
  
)

export default component.exports